import * as React from "react"

import { SKU_CANDIDATES_ROUTES, USER_ROLE } from "@constants"
import AppLayout from "Layout"
import SkuCandidatesPage from "./index"


export const SkuCandidatesRoutes = {
    path: SKU_CANDIDATES_ROUTES.PATH,
    title: SKU_CANDIDATES_ROUTES.TITLE,
    icon: 'boxes-packing',
    iconWeight: 'light',
    element: <AppLayout />,
    description: SKU_CANDIDATES_ROUTES.SUBTITLE,
    access: USER_ROLE.ADMIN,
    children: [{
        element: <SkuCandidatesPage />,
        index: true
    }]
}
